import { AxiosResponse } from "axios";
import axiosInstance from "../../api";
import suggestiveInputHelpers from "../helpers/suggestiveInputHelpers";

function PrimaryInsuranceSideEffect(
 token: string,
 testType: string,
 setSuggestions: (response: AxiosResponse) => any
) {
 axiosInstance
  .get(`v1/primary-insurance`, {
   headers: { Authorization: `Bearer ${token}` },
  })
  .then((response) => {
   if (response.data.data) {
    const suggestions: any = [{ value: 19, label: "Enter new insurance" }];
    response.data.data
     .sort(suggestiveInputHelpers.sortByAlphabeticalOrder)
     .forEach((item: any) =>
      suggestions.push({
       label: `${item.name}`,
       value: item.id,
      })
     );
    setSuggestions(suggestions);
   }
  });
}

export default PrimaryInsuranceSideEffect;
